import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import { Modal, Button, Form, CloseButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export function openPasswordModel(next, input = null, setLoading = null) {
  const div = document.createElement("div");
  document.body.appendChild(div);
  const root = createRoot(div);
  const close = () => {
    root.unmount();
    div.remove();
    document.body.style.overflow = "auto";
  };
  root.render(
    <PasswordModal
      show={true}
      onPasswordEntered={next}
      close={close}
      inputValue={input}
      setLoading={setLoading}
    />
  );
}

export function PasswordModal(props) {
  const { t } = useTranslation()
  const [password, setPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setPasswordsMatch(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    props.onPasswordEntered(password, props.inputValue);
    props.close();
  };

  const handleCancel = () => {
    // props.onPasswordEntered(null);
    if (props.setLoading) {
      props.setLoading(false);
    }
    props.close();
  };

  return (
    <Modal
      show={props.show}
      onHide={handleCancel}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      id="password-modal"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {t("general.horusWallet")}
        </Modal.Title>
        <CloseButton
          onClick={handleCancel}
          style={{ position: "absolute", right: "20px", top: "20px" }}
        />
      </Modal.Header>
      <Modal.Body>
        <p>
          {t("general.yourWalletEncyrptedNote")}
        </p>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formPassword">
            <Form.Control
              type="password"
              placeholder={t("horuspassmodalGmail.enterPass")}
              value={password}
              onChange={handlePasswordChange}
              isInvalid={!passwordsMatch}
            />
          </Form.Group>
          <br />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <div className="fugu--portfolio-btn">
          <button className="fugu--outline-btn" onClick={handleSubmit}>
            <span>{t("horuspassmodalEmail.submit")}</span>
          </button>
        </div>
        <div className="fugu--portfolio-btn">
          <button className="fugu--outline-btn" onClick={handleCancel}>
            <span>{t("horuspassmodalEmail.close")}</span>
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
